<template>
  <CreateAnnotationModal ref="createAnnotationModalRef" />
</template>

<script setup lang="ts">
import { onBeforeUnmount } from "vue";
import { DateTime } from "luxon";
import CreateAnnotationModal, {
  useCreateAnnotationModal,
} from "@/components/Modal/CreateAnnotationModal.vue";
import { registerAnnotationCreateOpener } from "@/composables/useAnnotationCreateShortcut";
import { useAnnotationsStore } from "@/store/annotations";

const annotationsStore = useAnnotationsStore();
const { createAnnotationModalRef, onClickCreateAnnotation } =
  useCreateAnnotationModal();

function openCreateAnnotation(): void {
  const { clickedDate } = annotationsStore;
  onClickCreateAnnotation(
    clickedDate ? DateTime.fromISO(clickedDate) : undefined,
  );
}

onBeforeUnmount(registerAnnotationCreateOpener(openCreateAnnotation));
</script>
